//api.js
import { debugLog } from './debug';

// Configuracoes da API do Chatwoot vindas do window._env_ (injetadas pelo .env.js)
// (restaurado apos regressao do commit 93bea63 que removeu essas linhas)
const CHATWOOT_URL = (window._env_ && window._env_.REACT_APP_CHATWOOT_URL) || '';
const ACCOUNT_ID = (window._env_ && window._env_.REACT_APP_CHATWOOT_ACCOUNT_ID) || '';
const TOKEN = (window._env_ && window._env_.REACT_APP_CHATWOOT_TOKEN) || '';

const chatwootHeaders = {
  'Content-Type': 'application/json',
  'api_access_token': TOKEN,
};

async function chatwootFetch(endpoint, options = {}) {
  const url = `${CHATWOOT_URL}/api/v1/accounts/${ACCOUNT_ID}${endpoint}`;
  debugLog('chatwootFetch', url, options);
  try {
    const response = await fetch(url, { ...options, headers: chatwootHeaders });
    const responseText = await response.text();
    let responseData;
    try {
      responseData = JSON.parse(responseText);
    } catch {
      responseData = responseText;
    }
    if (!response.ok) {
      const errorDetails = {
        message: `Erro na API: ${url} ${response.status}`,
        status: response.status,
        url,
        method: options.method || 'GET',
        requestBody: options.body,
        headers: chatwootHeaders,
        response: responseData,
        stack: (new Error()).stack
      };
      debugLog('Detalhes do erro Chatwoot:', errorDetails);
      const error = new Error(errorDetails.message);
      Object.assign(error, errorDetails);
      throw error;
    }
    return responseData;
  } catch (error) {
    debugLog('Erro na requisição Chatwoot:', error);
    throw error;
  }
}

debugLog('api.js: módulo carregado');

// Retorna todos os contatos
export async function getContacts() {
  debugLog('api.js: getContacts chamado');
  try {
    const data = await chatwootFetch('/contacts');
    return data.payload || [];
  } catch (error) {
    debugLog('Erro ao buscar contatos:', error);
    throw error;
  }
}

// Retorna todos os atributos customizados (contact_attribute + conversation_attribute)
// IFS patch (2026-07-21): removido filtro contact_attribute pra permitir Kanban
// em custom attributes de conversation (ex: estagio_tarefa).
export async function getCustomAttributes() {
  debugLog('api.js: getCustomAttributes chamado');
  try {
    // Busca todos os atributos customizados
    const data = await chatwootFetch('/custom_attribute_definitions');
    const all = data.payload || data || [];
    // Retorna ambos os tipos — o hook decide qual usar via attribute_model
    return Array.isArray(all) ? all : [];
  } catch (error) {
    debugLog('Erro ao buscar atributos customizados:', error);
    throw error;
  }
}

// Retorna um atributo customizado específico pelo ID
export async function getCustomAttributeById(id) {
  debugLog('api.js: getCustomAttributeById chamado', id);
  try {
    const data = await chatwootFetch(`/custom_attribute_definitions/${id}`);
    return data.payload || data; // pode vir como objeto direto
  } catch (error) {
    debugLog('Erro ao buscar atributo customizado por ID:', error);
    throw error;
  }
}

// Atualiza o valor de um atributo customizado do contato
export async function updateContactCustomAttribute(contactId, attributeKey, value) {
  debugLog('api.js: updateContactCustomAttribute chamado', contactId, attributeKey, value);
  try {
    return await chatwootFetch(`/contacts/${contactId}`, {
      method: 'PUT',
      body: JSON.stringify({ custom_attributes: { [attributeKey]: value } })
    });
  } catch (error) {
    debugLog('Erro ao atualizar atributo customizado:', error);
    throw error;
  }
}

// IFS patch (2026-07-21) — Support conversation attributes ============

// Retorna todas as conversations, paginando ate esgotar (ou limite)
export async function getConversations(maxPages = 50) {
  debugLog('api.js: getConversations chamado');
  try {
    const all = [];
    let page = 1;
    while (page <= maxPages) {
      const data = await chatwootFetch(`/conversations?page=${page}`);
      const payload = (data && data.data && data.data.payload) || data.payload || [];
      if (!payload || payload.length === 0) break;
      all.push(...payload);
      const meta = (data && data.data && data.data.meta) || data.meta || {};
      const total = meta.all_count || meta.total_count || 0;
      if (all.length >= total) break;
      // Se recebemos menos que uma pagina cheia, provavelmente acabou
      if (payload.length < 25) break;
      page += 1;
    }
    debugLog(`api.js: getConversations retornou ${all.length} conversas`);
    return all;
  } catch (error) {
    debugLog('Erro ao buscar conversations:', error);
    throw error;
  }
}

// Atualiza custom_attributes de uma conversation
// Endpoint: POST /api/v1/accounts/{account_id}/conversations/{id}/custom_attributes
// Body: { custom_attributes: { key: value } }
// NOTA: envia o objeto completo (nao merge no backend). Chamador precisa passar
// o dict inteiro atualizado quando quiser preservar outros attributes.
export async function updateConversationCustomAttributes(conversationId, customAttributes) {
  debugLog('api.js: updateConversationCustomAttributes chamado', conversationId, customAttributes);
  try {
    return await chatwootFetch(`/conversations/${conversationId}/custom_attributes`, {
      method: 'POST',
      body: JSON.stringify({ custom_attributes: customAttributes || {} })
    });
  } catch (error) {
    debugLog('Erro ao atualizar custom_attributes da conversation:', error);
    throw error;
  }
}